export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/OnlineCardsPromo_Mobile-956077656d6a890cf0a98680916bb55d.jpg";